<ng-container *ngIf="workplace">
  <ng-container *ngIf="!workplace?.showAddWorkplaceDetailsBanner">
    <div [class.govuk-summary-list__warning]="noVacancyAndTurnoverData" data-testid="vacancies-and-turnover-section">
      <h2
        class="govuk-heading-m govuk-!-padding-top-1 govuk-!-margin-top-4"
        [ngClass]="{ 'govuk-!-margin-bottom-1': noVacancyAndTurnoverData }"
      >
        Vacancies and turnover
      </h2>
      <span *ngIf="noVacancyAndTurnoverData" class="govuk-error-message govuk-summary-list__warning-message"
        >You've not added any vacancy and turnover data</span
      >
      <div [class.govuk-summary-list__warning]="noVacancyData" data-testid="vacancies">
        <dl
          class="govuk-summary-list govuk-summary-list--medium govuk-!-margin-bottom-0 govuk-summary-list--top-border"
        >
          <div
            class="govuk-summary-list__row"
            [ngClass]="{
              'govuk-summary-list__row--no-bottom-border': noVacancyData,
              'govuk-summary-list__row--no-bottom-padding': noVacancyData,
            }"
            data-testid="vacancies-top-row"
          >
            <dt class="govuk-summary-list__key">Current staff vacancies</dt>
            <dd class="govuk-summary-list__value">
              <app-summary-record-value>
                <ng-container *ngIf="!workplace.vacancies?.length; else vacancies"> - </ng-container>
                <ng-template #vacancies>
                  <ng-container *ngIf="isArray(workplace.vacancies)">
                    <ul class="govuk-list govuk-!-margin-bottom-0">
                      <li *ngFor="let vacancy of workplace.vacancies">{{ vacancy | formatSLV }}</li>
                    </ul>
                  </ng-container>
                  <ng-container *ngIf="!isArray(workplace.vacancies)"
                    >{{ workplace.vacancies | closedEndedAnswer }}
                  </ng-container>
                </ng-template>
              </app-summary-record-value>
            </dd>
            <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
              <app-summary-record-change
                [explanationText]="' staff vacancies'"
                [link]="'update-vacancies' | workplaceSummaryPath: workplace.uid"
                [hasData]="workplace.vacancies?.length"
                (setReturnClicked)="this.clearPreviouslySelectedJobRolesAndSetReturn()"
              ></app-summary-record-change>
            </dd>
          </div>
          <div *ngIf="noVacancyData" class="govuk-summary-list__row govuk-summary-list__row--error-warning-message">
            <dt class="govuk-summary-list__key govuk-error-message govuk-summary-list__warning-message govuk__nowrap">
              You've not added any staff vacancy data
            </dt>
            <dd class="govuk-summary-list__value"></dd>
            <dd class="govuk-summary-list__actions"></dd>
          </div>
        </dl>
      </div>
      <dl class="govuk-summary-list govuk-summary-list--medium">
        <div class="govuk-summary-list__row" data-testid="starters">
          <dt class="govuk-summary-list__key">Starters in the last 12 months</dt>
          <dd class="govuk-summary-list__value">
            <app-summary-record-value>
              <ng-container *ngIf="!workplace.starters?.length; else starters"> - </ng-container>
              <ng-template #starters>
                <ng-container *ngIf="isArray(workplace.starters)">
                  <ul class="govuk-list govuk-!-margin-bottom-0">
                    <li *ngFor="let starter of workplace.starters">{{ starter | formatSLV }}</li>
                  </ul>
                </ng-container>
                <ng-container *ngIf="!isArray(workplace.starters)">
                  {{ workplace.starters | closedEndedAnswer }}
                </ng-container>
              </ng-template>
            </app-summary-record-value>
          </dd>
          <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
            <app-summary-record-change
              [explanationText]="' new starters'"
              [link]="'update-starters' | workplaceSummaryPath: workplace.uid"
              [hasData]="workplace.starters?.length"
              (setReturnClicked)="this.clearPreviouslySelectedJobRolesAndSetReturn()"
            ></app-summary-record-change>
          </dd>
        </div>

        <div class="govuk-summary-list__row" data-testid="leavers">
          <dt class="govuk-summary-list__key">Leavers in the last 12 months</dt>
          <dd class="govuk-summary-list__value">
            <app-summary-record-value>
              <ng-container *ngIf="!workplace.leavers?.length; else leavers"> - </ng-container>
              <ng-template #leavers>
                <ng-container *ngIf="isArray(workplace.leavers)">
                  <ul class="govuk-list govuk-!-margin-bottom-0">
                    <li *ngFor="let leaver of workplace.leavers">{{ leaver | formatSLV }}</li>
                  </ul>
                </ng-container>
                <ng-container *ngIf="!isArray(workplace.leavers)">
                  {{ workplace.leavers | closedEndedAnswer }}
                </ng-container>
              </ng-template>
            </app-summary-record-value>
          </dd>
          <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
            <app-summary-record-change
              [explanationText]="' leavers'"
              [link]="'update-leavers' | workplaceSummaryPath: workplace.uid"
              [hasData]="workplace.leavers?.length"
              (setReturnClicked)="this.clearPreviouslySelectedJobRolesAndSetReturn()"
            ></app-summary-record-change>
          </dd>
        </div>
      </dl>
    </div>
  </ng-container>
  <div class="govuk-width-container govuk-!-margin-top-5">
    <h2 class="govuk-heading-m govuk-!-margin-bottom-5">Workplace details</h2>
  </div>

  <div data-testid="workplace-section">
    <dl class="govuk-summary-list govuk-summary-list--medium govuk-!-margin-bottom-0 govuk-summary-list--top-border">
      <div
        *ngIf="workplace?.isRegulated"
        class="govuk-summary-list__row"
        [class.govuk-summary-list__row--no-bottom-border]="numberOfStaffError || numberOfStaffWarning"
        data-testid="cqcLocationId"
      >
        <dt class="govuk-summary-list__key">CQC location ID</dt>
        <dd class="govuk-summary-list__value">
          {{ workplace.locationId }}
        </dd>
        <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
          <a [routerLink]="'regulated-by-cqc' | workplaceSummaryPath: workplace.uid" (click)="setReturn()"> Change </a>
        </dd>
      </div>
    </dl>

    <div
      [class.govuk-summary-list__error]="numberOfStaffError"
      [class.govuk-summary-list__warning]="!numberOfStaffError && numberOfStaffWarning"
      data-testid="numberOfStaff"
    >
      <dl
        class="govuk-summary-list govuk-summary-list--medium govuk-!-margin-bottom-0"
        [class.govuk-summary-list--top-border]="numberOfStaffError || numberOfStaffWarning"
      >
        <div
          class="govuk-summary-list__row"
          [ngClass]="{
            'govuk-summary-list__row--no-bottom-border': numberOfStaffError || numberOfStaffWarning,
            'govuk-summary-list__row--no-bottom-padding': numberOfStaffError || numberOfStaffWarning,
          }"
          data-testid="number-of-staff-top-row"
        >
          <dt class="govuk-summary-list__key">Number of staff</dt>
          <dd class="govuk-summary-list__value">
            <app-summary-record-value>
              {{ workplace.numberOfStaff | numericAnswer }}
            </app-summary-record-value>
          </dd>
          <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
            <app-summary-record-change
              [explanationText]="' total number of staff'"
              [link]="'total-staff' | workplaceSummaryPath: workplace.uid"
              [hasData]="workplace.numberOfStaff | hasValue"
              (setReturnClicked)="this.setReturn()"
            ></app-summary-record-change>
          </dd>
        </div>
        <div *ngIf="numberOfStaffError" class="govuk-summary-list__row govuk-summary-list__row--error-warning-message">
          <dt class="govuk-summary-list__key govuk-error-message govuk__nowrap">
            You need to add your total number of staff
          </dt>
          <dd class="govuk-summary-list__value"></dd>
          <dd class="govuk-summary-list__actions"></dd>
        </div>
        <div
          *ngIf="!numberOfStaffError && numberOfStaffWarning"
          class="govuk-summary-list__row govuk-summary-list__row--error-warning-message"
        >
          <dt class="govuk-summary-list__key govuk-error-message govuk-summary-list__warning-message govuk__nowrap">
            {{
              workplace.numberOfStaff > workerCount
                ? "You've more staff than staff records"
                : "You've more staff records than staff"
            }}
          </dt>
          <dd *ngIf="canViewListOfWorkers" class="govuk-summary-list__value">
            <a (click)="navigateToTab($event, 'staff-records')" href="#"> View staff records </a>
          </dd>
          <dd class="govuk-summary-list__actions"></dd>
        </div>
      </dl>
    </div>

    <dl class="govuk-summary-list govuk-summary-list--medium">
      <div class="govuk-summary-list__row" data-testid="employerType">
        <dt class="govuk-summary-list__key">Employer type</dt>
        <dd class="govuk-summary-list__value">
          <app-summary-record-value>
            <ng-container *ngIf="!(workplace.employerType?.other || typeOfEmployer); else employertype">
              -
            </ng-container>
            <ng-template #employertype>
              {{ workplace.employerType?.other ? workplace.employerType.other : typeOfEmployer }}
            </ng-template>
          </app-summary-record-value>
        </dd>
        <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
          <app-summary-record-change
            [explanationText]="'employer type'"
            [link]="'type-of-employer' | workplaceSummaryPath: workplace.uid"
            [hasData]="workplace.employerType?.other || workplace.employerType?.value"
            (setReturnClicked)="this.setReturn()"
          ></app-summary-record-change>
        </dd>
      </div>
    </dl>
  </div>

  <h2 class="govuk-heading-m govuk-!-padding-top-1">Services</h2>
  <dl
    *ngIf="workplace"
    class="govuk-summary-list govuk-summary-list--medium govuk-summary-list--top-border"
    data-testid="services-section"
  >
    <div
      class="govuk-summary-list__row"
      [ngClass]="{ 'govuk-panel--light-blue': cqcStatusRequested }"
      data-testid="mainService"
    >
      <dt class="govuk-summary-list__key" [ngClass]="{ 'govuk-!-padding-left-3': cqcStatusRequested }">Main service</dt>
      <dd class="govuk-summary-list__value" data-testid="main-service-name">
        <app-summary-record-value>
          {{ cqcStatusRequested ? requestedServiceName : workplace.mainService?.name }}
          <ng-container
            *ngIf="
              (cqcStatusRequested && requestedServiceOtherName) || (workplace.mainService?.other && !cqcStatusRequested)
            "
          >
            - {{ cqcStatusRequested ? requestedServiceOtherName : workplace.mainService?.other }}
          </ng-container>
        </app-summary-record-value>
      </dd>
      <dd
        *ngIf="canEditEstablishment"
        class="govuk-summary-list__actions"
        [ngClass]="{ 'govuk-!-padding-right-3': cqcStatusRequested }"
        data-testid="main-service-change-or-pending"
      >
        <ng-container>
          <a
            *ngIf="!cqcStatusRequested; else cqcPending"
            [routerLink]="'main-service-cqc' | workplaceSummaryPath: workplace.uid"
            (click)="setReturn()"
          >
            <ng-container *ngIf="!workplace.mainService">
              Provide information
              <span class="govuk-visually-hidden"> for</span>
            </ng-container>
            <ng-container *ngIf="workplace.mainService"> Change </ng-container>
            <span class="govuk-visually-hidden"> main service</span>
          </a>
          <ng-template #cqcPending>
            <ng-container> Pending </ng-container>
            <span class="govuk-visually-hidden"> main service</span>
          </ng-template>
        </ng-container>
      </dd>
    </div>
    <div *ngIf="!workplace.showAddWorkplaceDetailsBanner" class="govuk-summary-list__row" data-testid="otherServices">
      <dt class="govuk-summary-list__key">Other services</dt>
      <dd class="govuk-summary-list__value">
        <ng-container [ngSwitch]="workplace.otherServices.value || null">
          <span *ngSwitchCase="null"> - </span>
          <span *ngSwitchCase="'No'"> None </span>
          <div *ngSwitchCase="'Yes'">
            <ul class="govuk-list govuk-!-margin-bottom-0">
              <ng-container *ngFor="let service of filterAndSortOtherServices(workplace.otherServices.services)">
                <li>
                  {{ service.name }}<ng-container *ngIf="service.other">: {{ service.other }}</ng-container>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-container>
      </dd>
      <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
        <app-summary-record-change
          [explanationText]="' other services'"
          [link]="'other-services' | workplaceSummaryPath: workplace.uid"
          [hasData]="workplace.otherServices.value !== null"
          (setReturnClicked)="this.setReturn()"
        ></app-summary-record-change>
      </dd>
    </div>
    <div
      *ngIf="!workplace.showAddWorkplaceDetailsBanner && hasCapacity"
      class="govuk-summary-list__row"
      data-testid="serviceCapacity"
    >
      <dt class="govuk-summary-list__key">Service capacity</dt>
      <dd class="govuk-summary-list__value">
        <app-summary-record-value>
          <ng-container *ngIf="!workplace.capacities?.length; else capacities"> - </ng-container>
          <ng-template #capacities>
            <ul class="govuk-list govuk-!-margin-bottom-0">
              <li *ngFor="let capacity of capacityMessages">{{ capacity.message }}</li>
            </ul>
          </ng-template>
        </app-summary-record-value>
      </dd>
      <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
        <app-summary-record-change
          [explanationText]="' service capacities'"
          [link]="'capacity-of-services' | workplaceSummaryPath: workplace.uid"
          [hasData]="workplace.capacities?.length"
          (setReturnClicked)="this.setReturn()"
        ></app-summary-record-change>
      </dd>
    </div>

    <div *ngIf="!workplace.showAddWorkplaceDetailsBanner" class="govuk-summary-list__row" data-testid="serviceUsers">
      <dt class="govuk-summary-list__key">Service users</dt>
      <dd class="govuk-summary-list__value">
        <app-summary-record-value>
          <ng-container *ngIf="!workplace.serviceUsers?.length; else serviceUsers"> - </ng-container>
          <ng-template #serviceUsers>
            <ul class="govuk-list govuk-!-margin-bottom-0">
              <li *ngFor="let users of workplace.serviceUsers">
                {{ users.service }}
                <ng-container *ngIf="users.other"> - {{ users.other }}</ng-container>
              </li>
            </ul>
          </ng-template>
        </app-summary-record-value>
      </dd>
      <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
        <app-summary-record-change
          [explanationText]="' service users'"
          [link]="'service-users' | workplaceSummaryPath: workplace.uid"
          [hasData]="workplace.serviceUsers?.length"
          (setReturnClicked)="this.setReturn()"
        ></app-summary-record-change>
      </dd>
    </div>

    <div
      *ngIf="!workplace.showAddWorkplaceDetailsBanner && workplace.mainService?.canDoDelegatedHealthcareActivities"
      class="govuk-summary-list__row"
      data-testid="carryOutDelegatedHealthcareActivities"
    >
      <dt class="govuk-summary-list__key">Carry out delegated healthcare activities</dt>
      <dd class="govuk-summary-list__value">
        <app-summary-record-value>
          {{ workplace.staffDoDelegatedHealthcareActivities | closedEndedAnswer }}
        </app-summary-record-value>
      </dd>
      <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
        <app-summary-record-change
          [explanationText]="' delegated healthcare activities'"
          [link]="'staff-do-delegated-healthcare-activities' | workplaceSummaryPath: workplace.uid"
          [hasData]="workplace.staffDoDelegatedHealthcareActivities"
          (setReturnClicked)="this.setReturn()"
        ></app-summary-record-change>
      </dd>
    </div>

    <div
      class="govuk-summary-list__row"
      *ngIf="
        workplace.staffDoDelegatedHealthcareActivities === 'Yes' &&
        workplace.mainService?.canDoDelegatedHealthcareActivities
      "
      data-testid="know-what-delegated-healthcare-activities"
    >
      <dt class="govuk-summary-list__key">Which delegated healthcare activities</dt>
      <dd class="govuk-summary-list__value">
        <ng-container
          *ngIf="workplace.staffWhatKindDelegatedHealthcareActivities?.knowWhatActivities === 'Yes'; else noActivities"
        >
          <ul class="govuk-list govuk-!-margin-bottom-0">
            <li *ngFor="let activity of workplace.staffWhatKindDelegatedHealthcareActivities.activities">
              {{ activity.title }}
            </li>
          </ul>
        </ng-container>
        <ng-template #noActivities>
          {{ workplace.staffWhatKindDelegatedHealthcareActivities | formatWhatDHA }}
        </ng-template>
      </dd>
      <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
        <app-summary-record-change
          [explanationText]="' delegated healthcare activities carried out'"
          [link]="'what-kind-of-delegated-healthcare-activities' | workplaceSummaryPath: workplace.uid"
          [hasData]="workplace.staffWhatKindDelegatedHealthcareActivities"
          (setReturnClicked)="this.setReturn()"
        ></app-summary-record-change>
      </dd>
    </div>
  </dl>

  <ng-container *ngIf="!workplace?.showAddWorkplaceDetailsBanner">
    <h2 class="govuk-heading-m govuk-!-padding-top-1">Recruitment and benefits</h2>
    <dl
      class="govuk-summary-list govuk-summary-list--medium govuk-summary-list--top-border"
      data-testid="recruitment-and-benefits-section"
    >
      <div class="govuk-summary-list__row" data-testid="repeat-training">
        <dt class="govuk-summary-list__key">Repeat training</dt>
        <dd class="govuk-summary-list__value">
          <app-summary-record-value>
            <ng-container
              *ngIf="
                !workplace.doNewStartersRepeatMandatoryTrainingFromPreviousEmployment;
                else doNewStartersRepeatMandatoryTrainingFromPreviousEmploymentType
              "
            >
              -
            </ng-container>
            <ng-template #doNewStartersRepeatMandatoryTrainingFromPreviousEmploymentType>
              {{ workplace.doNewStartersRepeatMandatoryTrainingFromPreviousEmployment }}
            </ng-template>
          </app-summary-record-value>
        </dd>
        <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
          <app-summary-record-change
            [explanationText]="' repeat training'"
            [link]="'staff-recruitment-capture-training-requirement' | workplaceSummaryPath: workplace.uid"
            [hasData]="workplace.doNewStartersRepeatMandatoryTrainingFromPreviousEmployment"
            (setReturnClicked)="this.setReturn()"
          ></app-summary-record-change>
        </dd>
      </div>

      <div class="govuk-summary-list__row" data-testid="accept-care-certificate">
        <dt class="govuk-summary-list__key">Accept Care Certificate</dt>
        <dd class="govuk-summary-list__value">
          <app-summary-record-value>
            <ng-container
              *ngIf="
                !workplace.wouldYouAcceptCareCertificatesFromPreviousEmployment;
                else wouldYouAcceptCareCertificatesFromPreviousEmploymentType
              "
            >
              -
            </ng-container>
            <ng-template #wouldYouAcceptCareCertificatesFromPreviousEmploymentType>
              {{ workplace.wouldYouAcceptCareCertificatesFromPreviousEmployment }}
            </ng-template>
          </app-summary-record-value>
        </dd>
        <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
          <app-summary-record-change
            [explanationText]="' accept care certificate'"
            [link]="'accept-previous-care-certificate' | workplaceSummaryPath: workplace.uid"
            [hasData]="workplace.wouldYouAcceptCareCertificatesFromPreviousEmployment"
            (setReturnClicked)="this.setReturn()"
          ></app-summary-record-change>
        </dd>
      </div>

      <div class="govuk-summary-list__row" data-testid="care-workforce-pathway-awareness">
        <dt class="govuk-summary-list__key">Care workforce pathway aware</dt>
        <dd class="govuk-summary-list__value">
          {{ workplace.careWorkforcePathwayWorkplaceAwareness | formatCWPWorkplaceAwareness }}
        </dd>
        <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
          <app-summary-record-change
            [explanationText]="' care workforce pathway aware'"
            [link]="'care-workforce-pathway-awareness' | workplaceSummaryPath: workplace.uid"
            [hasData]="workplace.careWorkforcePathwayWorkplaceAwareness"
            (setReturnClicked)="this.setReturn()"
          ></app-summary-record-change>
        </dd>
      </div>
      <div
        class="govuk-summary-list__row"
        data-testid="care-workforce-pathway-use"
        *ngIf="isAwareOfCareWorkforcePathway"
      >
        <dt class="govuk-summary-list__key">Using the care workforce pathway</dt>
        <dd class="govuk-summary-list__value">
          <ng-container *ngIf="!isArray(workplace.careWorkforcePathwayUse | formatCWPUse); else listReasons">
            {{ workplace.careWorkforcePathwayUse | formatCWPUse }}
          </ng-container>

          <ng-template #listReasons>
            <ul class="govuk-list govuk-!-margin-bottom-0">
              <li *ngFor="let reason of workplace.careWorkforcePathwayUse | formatCWPUse">{{ reason }}</li>
            </ul>
          </ng-template>
        </dd>
        <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
          <app-summary-record-change
            [explanationText]="' care workforce pathway use'"
            [link]="'care-workforce-pathway-use' | workplaceSummaryPath: workplace.uid"
            [hasData]="workplace.careWorkforcePathwayUse"
            (setReturnClicked)="this.setReturn()"
          ></app-summary-record-change>
        </dd>
      </div>

      <div class="govuk-summary-list__row" data-testid="cash-loyalty-bonus-spend">
        <dt class="govuk-summary-list__key">Cash loyalty bonus</dt>
        <dd class="govuk-summary-list__value">
          <app-summary-record-value>
            <ng-container
              *ngIf="!workplace.careWorkersCashLoyaltyForFirstTwoYears; else careWorkersCashLoyaltyForFirstTwoYearsType"
            >
              -
            </ng-container>
            <ng-template #careWorkersCashLoyaltyForFirstTwoYearsType>
              <ng-container
                *ngIf="
                  workplace.careWorkersCashLoyaltyForFirstTwoYears === 'No' ||
                    workplace.careWorkersCashLoyaltyForFirstTwoYears === 'Don\'t know' ||
                    workplace.careWorkersCashLoyaltyForFirstTwoYears === 'Yes';
                  then careWorkersCashLoyaltyForFirstTwoYearsNotKnown;
                  else careWorkersCashLoyaltyForFirstTwoYearsKnown
                "
              >
              </ng-container>
              <ng-template #careWorkersCashLoyaltyForFirstTwoYearsNotKnown>
                {{ workplace.careWorkersCashLoyaltyForFirstTwoYears }}
              </ng-template>
              <ng-template #careWorkersCashLoyaltyForFirstTwoYearsKnown>
                £{{ this.formatMonetaryValue(workplace.careWorkersCashLoyaltyForFirstTwoYears) }}
              </ng-template>
            </ng-template>
          </app-summary-record-value>
        </dd>
        <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
          <app-summary-record-change
            [explanationText]="' loyalty bonus'"
            [link]="'cash-loyalty' | workplaceSummaryPath: workplace.uid"
            [hasData]="workplace.careWorkersCashLoyaltyForFirstTwoYears"
            (setReturnClicked)="this.setReturn()"
          ></app-summary-record-change>
        </dd>
      </div>

      <div class="govuk-summary-list__row" data-testid="offer-more-than-statutory-sick-pay">
        <dt class="govuk-summary-list__key">Offer more than Statutory Sick Pay</dt>
        <dd class="govuk-summary-list__value">
          <app-summary-record-value>
            <ng-container *ngIf="!workplace.sickPay; else sickPayType"> - </ng-container>
            <ng-template #sickPayType>
              {{ workplace.sickPay }}
            </ng-template>
          </app-summary-record-value>
        </dd>
        <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
          <app-summary-record-change
            [explanationText]="' statutory sick pay'"
            [link]="'benefits-statutory-sick-pay' | workplaceSummaryPath: workplace.uid"
            [hasData]="workplace.sickPay"
            (setReturnClicked)="this.setReturn()"
          ></app-summary-record-change>
        </dd>
      </div>

      <div class="govuk-summary-list__row" data-testid="higher-pension-contributions">
        <dt class="govuk-summary-list__key">Higher pension contributions</dt>
        <dd class="govuk-summary-list__value">
          <app-summary-record-value>
            <ng-container *ngIf="!workplace.pensionContribution; else pensionContributionType"> - </ng-container>
            <ng-template #pensionContributionType>
              {{ workplace.pensionContribution }}
            </ng-template>
          </app-summary-record-value>
        </dd>
        <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
          <app-summary-record-change
            [explanationText]="' pension'"
            [link]="'pensions' | workplaceSummaryPath: workplace.uid"
            [hasData]="workplace.pensionContribution"
            (setReturnClicked)="this.setReturn()"
          ></app-summary-record-change>
        </dd>
      </div>

      <div class="govuk-summary-list__row" data-testid="number-of-days-leave">
        <dt class="govuk-summary-list__key">Number of days leave</dt>
        <dd class="govuk-summary-list__value">
          <app-summary-record-value>
            <ng-container *ngIf="!workplace.careWorkersLeaveDaysPerYear; else careWorkersLeaveDaysPerYearType">
              -
            </ng-container>
            <ng-template #careWorkersLeaveDaysPerYearType>
              {{ workplace.careWorkersLeaveDaysPerYear }}
            </ng-template>
          </app-summary-record-value>
        </dd>
        <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
          <app-summary-record-change
            [explanationText]="' holiday leave'"
            [link]="'staff-benefit-holiday-leave' | workplaceSummaryPath: workplace.uid"
            [hasData]="workplace.careWorkersLeaveDaysPerYear"
            (setReturnClicked)="this.setReturn()"
          ></app-summary-record-change>
        </dd>
      </div>
    </dl>

    <h2 class="govuk-heading-m govuk-!-padding-top-1">Permissions</h2>
    <dl
      class="govuk-summary-list govuk-summary-list--medium govuk-summary-list--top-border"
      data-testid="permissions-section"
    >
      <div class="govuk-summary-list__row" data-testid="data-sharing">
        <dt class="govuk-summary-list__key">Data sharing</dt>
        <dd class="govuk-summary-list__value">
          <ng-container *ngIf="!workplace.shareWith?.cqc && !workplace.shareWith?.localAuthorities; else sharing">
            <ng-container
              *ngIf="
                workplace.shareWith?.cqc === false || workplace.shareWith?.localAuthorities === false;
                else notProvided
              "
            >
              Not sharing
            </ng-container>
            <ng-template #notProvided> - </ng-template>
          </ng-container>
          <ng-template #sharing>
            <p *ngIf="workplace.shareWith?.cqc">Care Quality Commission (CQC)</p>
            <p *ngIf="workplace.shareWith?.localAuthorities">Local authorities</p>
          </ng-template>
        </dd>
        <dd *ngIf="canEditEstablishment" class="govuk-summary-list__actions">
          <app-summary-record-change
            [explanationText]="' data sharing'"
            [link]="'sharing-data' | workplaceSummaryPath: workplace.uid"
            [hasData]="workplace.shareWith?.cqc !== null || workplace.shareWith?.localAuthorities !== null"
            (setReturnClicked)="this.setReturn()"
          ></app-summary-record-change>
        </dd>
      </div>
    </dl>
  </ng-container>
</ng-container>
